// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"header-search-bar_searchWrapper__2KYSe","search":"header-search-bar_search__2vZLP"};